module.exports = __webpack_public_path__ + "static/media/session-detail-calendar.9bdd8a9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/session-detail-calendar.svg
// module id = 835
// module chunks = 1